import { useState } from "react";
import { Pencil, Check, X } from "lucide-react";

export function OdometerValue({ value, onSave, testId }) {
  const [editing, setEditing] = useState(false);
  const [v, setV] = useState("");
  const [busy, setBusy] = useState(false);
  if (!editing) {
    return (
      <span className="inline-flex items-center gap-1">
        <span className="font-mono text-slate-200" data-testid={`${testId}-value`}>{value ?? "—"}</span>
        {onSave && (
          <button type="button" title="Editar odômetro" onClick={() => { setV(value ?? ""); setEditing(true); }}
            data-testid={`${testId}-edit`} className="rounded p-0.5 text-orange-300 transition-colors hover:bg-slate-800 hover:text-orange-200">
            <Pencil className="h-3 w-3" />
          </button>
        )}
      </span>
    );
  }
  const save = async () => {
    const n = Number(String(v).replace(",", "."));
    if (String(v).trim() === "" || Number.isNaN(n) || n < 0) return;
    setBusy(true);
    try { if (await onSave(n)) setEditing(false); } finally { setBusy(false); }
  };
  return (
    <span className="inline-flex items-center gap-1">
      <input type="number" step="1" min="0" value={v} autoFocus onChange={(e) => setV(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter") save(); if (e.key === "Escape") setEditing(false); }}
        data-testid={`${testId}-input`} className="h-6 w-24 rounded border border-slate-700 bg-slate-950 px-1.5 font-mono text-xs text-slate-100" />
      <button type="button" disabled={busy} onClick={save} data-testid={`${testId}-save`} className="rounded p-0.5 text-emerald-300 hover:bg-slate-800 disabled:opacity-50"><Check className="h-3.5 w-3.5" /></button>
      <button type="button" onClick={() => setEditing(false)} data-testid={`${testId}-cancel`} className="rounded p-0.5 text-slate-400 hover:bg-slate-800"><X className="h-3.5 w-3.5" /></button>
    </span>
  );
}
